import React from 'react';
import { Avatar, Box, Icon, Typography } from '@popmenu/common-ui';
import { ThumbsUp } from '@popmenu/web-icons';
import type { RootPlaceMenuItemWithReviewsQuery_rootPlace_RootPlace_menuItem_MenuItem_paginatedReviews_ReviewPaginationHandler_records_Review as ReviewType } from '../../../libs/gql/queries/root_places/rootPlaceMenuItemWithReviewsQuery.generated';
import { makeStyles } from '../../../utils/withStyles';
import { formatNumber } from '../../../utils/numbers';
import { nl2br } from '../../../utils/react';
import { useRelativeFormatTimeStamp } from '../../../utils/useRelativeFormatTimeStamp';

const useStyles = makeStyles(theme => ({
  avatar: {
    float: 'left',
    height: theme.spacing(3),
    width: theme.spacing(3),
  },
  container: {
    '&:last-child': {
      marginBottom: 0,
    },
    marginBottom: theme.spacing(4),
  },
  containerInner: {
    marginLeft: theme.spacing(5),
  },
  likeContainer: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  likeIcon: {
    fontSize: '1rem',
    fontWeight: 'bold',
    marginRight: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    position: 'relative',
  },
  nameContainer: {
    color: theme.palette.text.secondary,
    display: 'flex',
    fontSize: '0.8rem',
    justifyContent: 'space-between',
  },
}));

export const DishReview = ({ review }: { review: ReviewType }) => {
  const classes = useStyles();
  const reviewUpvotesCount = review.reviewUpvotesCount ?? 0;
  const formatTimestamp = useRelativeFormatTimeStamp();

  return (
    <Box className={classes.container}>
      <Avatar
        alt={review.userDisplayName}
        className={classes.avatar}
        src={review.userAvatarUrl}
      />
      <Box className={classes.containerInner}>
        <Box className={classes.nameContainer}>
          <span>{review.userDisplayName}</span>
          <span>{formatTimestamp(review.createdAt)}</span>
        </Box>
        <Typography>
          {nl2br(review.content)}
        </Typography>
        <Typography className={classes.likeContainer}>
          <Icon
            aria-label="Thumbs Up"
            className={classes.likeIcon}
            icon={ThumbsUp}
          />
          {reviewUpvotesCount > 0 && formatNumber(reviewUpvotesCount)}
        </Typography>
      </Box>
    </Box>
  );
};
